import axios from "axios";
export const GET_META_INFORMATION = "GET_META_INFORMATION";
export const TOGGLE_SPINNER = "TOGGLE_SPINNER";
export const TOGGLE_ERROR = "TOGGLE_ERROR";
export const GET_USER_EMAIL = "GET_USER_EMAIL";
export const KEYWORDS_LAST_UPDATED = "KEYWORDS_LAST_UPDATED";
export const NEXT_UPDATE_OF_KEYWORDS = "NEXT_UPDATE_OF_KEYWORDS";
export const IS_IT_TIME_FOR_UPDATE = "IS_IT_TIME_FOR_UPDATE";
export const TOP_100_FOR_SELECTED_KEYWORDS = "TOP_100_FOR_SELECTED_KEYWORDS";

export const addToGlobalStateActionWithThunk = (metaToAdd) => {
  return async (dispatch, getState) => {
    console.log("this action has been dispatched by a thunk action creator!");
    console.log(
      "you can even check the current state before the dispatch!",
      getState()
    );
    dispatch({
      type: GET_META_INFORMATION,
      payload: metaToAdd,
    });
  };
};

export const getMetaInformation = (props) => {
  return async (dispatch, getState) => {
    console.log("HELELLEO");
    try {
      console.log(props, "URL3");
      if (!getState().meta.isLoading) {
        dispatch({
          type: TOGGLE_SPINNER,
        });
      }
      const response = await axios(
        process.env.REACT_APP_FREE_META_TITLE_AND_DESCRIPTION_CHECKER_ENDPOINT,
        {
          params: { url: props },
        }
      );
      if (response) {
        console.log("this is the URL:", props);
        let html = await response.data;
        console.log(html);

        const title = html.title;
        const description = html.description;
        const image = html.image;
        const site_name = html.site_name;
        const icon = html.icon;
        const keywords = html.keywords;

        // I am dispatching to global state here:
        dispatch(
          addToGlobalStateActionWithThunk({
            title,
            description,
            image,
            site_name,
            icon,
            keywords,
          })
        );
        // let's toggle the spinner off!
        dispatch({
          type: TOGGLE_SPINNER,
        });
      } else {
        // let's toggle the spinner off!
        dispatch({
          type: TOGGLE_SPINNER,
        });
        dispatch({
          type: TOGGLE_ERROR,
        });
      }
    } catch (error) {
      // let's toggle the spinner off!
      dispatch({
        type: TOGGLE_SPINNER,
      });
      dispatch({
        type: TOGGLE_ERROR,
      });
    }
  };
};

export const getUserInformation = (payload) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_USER_EMAIL,
        payload: payload,
      });
    } catch (error) {
      console.log("Redux email error:", error);
    }
  };
};

export const isItTimeForUpdateReduxFunction = (payload) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: IS_IT_TIME_FOR_UPDATE,
        payload: payload,
      });
    } catch (error) {
      console.log("Redux  error:", error);
    }
  };
};

export const dispatchKeywordsLastUpdatedToReduxStore = (payload) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: KEYWORDS_LAST_UPDATED,
        payload: payload,
      });
    } catch (error) {
      console.log("Redux  error:", error);
    }
  };
};

export const dispatchNextUpdateOfKeywordsToReduxStore = (payload) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: NEXT_UPDATE_OF_KEYWORDS,
        payload: payload,
      });
    } catch (error) {
      console.log("Redux  error:", error);
    }
  };
};

export const dispatchTop100ForAllKeywordsToReduxStore = (payload) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: TOP_100_FOR_SELECTED_KEYWORDS,
        payload: payload,
      });
    } catch (error) {
      console.log("Redux  error:", error);
    }
  };
};
